module.exports = __webpack_public_path__ + "images/energy-label-water-a-l.b9df71.svg";